// extracted by mini-css-extract-plugin
export default {"header":"Styles_header__NuzN4","title":"Styles_title__eBJem","button":"Styles_button__o22tV"};